// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__211E9","inputDescription":"styles_inputDescription__Rxj6r"};